/**
 * @file tooltip.js
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakTooltip = {
    attach: function (context, settings) {

      // specifications show more button
      if($('.see-all-specifications-wrapper').length > 0) {
        $('.see-all-specifications').click(function (e) {
          e.preventDefault();
          $(this).addClass('active');
          $(this).parents('.see-all-specifications-wrapper').find('.collapse-specifications').addClass('active');
          $(this).parents('.see-all-specifications-wrapper').prev('.product-specifications').find('.moreitems').addClass('show');
          return false;
        });

        $('.collapse-specifications').click(function (e) {
          e.preventDefault();
          $(this).removeClass('active');
          $(this).parents('.see-all-specifications-wrapper').find('.see-all-specifications').removeClass('active');
          $(this).parents('.see-all-specifications-wrapper').prev('.product-specifications').find('.moreitems').removeClass('show');
          $('html, body').animate({
            scrollTop: $(this).parents('.see-all-specifications-wrapper').offset().top - 180
          }, 10);
          return false;
        });
      }

      // Global tooltip
      $(".tooltip").each(function () {
        $(this).hover(
          function () {
            let tooltip = $(this).find(".tooltiptext");
            tooltip.addClass("show");

            // Get the positions
            let tooltipOffset = tooltip.offset();
            let tooltipWidth = tooltip.outerWidth();
            let windowWidth = $(window).width();
            let totalWidth = parseInt(tooltipOffset.left + tooltipWidth);

            // Adjust tooltip if it's going out of the viewport
            if (totalWidth > windowWidth - 150) {
              let checkDiff = totalWidth - (windowWidth - 150);
              if(checkDiff > 30) {
                tooltip.addClass("left-adjust").removeClass("right-adjust");
              } else {
                tooltip.addClass("right-adjust").removeClass("left-adjust");
              }
            } else {
              tooltip.addClass("right-adjust").removeClass("left-adjust");
            }
          },
          function () {
            // Remove the tooltip on mouse leave
            let tooltip = $(this).find(".tooltiptext");
            tooltip.removeClass("show left-adjust right-adjust");
          }
        );
      });
    },
  };
})(jQuery, Drupal, once);
